import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/v2/components/Button';
import ButtonLink from 'app/components/v2/components/ButtonLink';
import Flex from 'app/components/v2/components/Flex';
import Heading4 from 'app/components/v2/components/Text/Heading4';

// Local Typings
interface Props {
  onClickReject: () => void;
}

// Local Variables
const chromeLink = 'https://www.google.com/chrome/';
const firefoxLink = 'https://www.mozilla.org/en-US/firefox/';

// Component Definition
const ModernBrowserPromptUI: FC<Props> = props => {
  const { t } = useTranslation('components');

  return (
    <Flex flexDirection="column">
      <Heading4>
        {/* eslint-disable-next-line @stylistic/max-len */}
        {t('interstitials.modernBrowser.heading', 'Want a better web experience? Visit us on a modern browser such as Chrome or Firefox.')}
      </Heading4>

      <Flex flexWrap="wrap">
        <ButtonLink
          href={chromeLink}
          margin={2}
          marginBottom={0}
          target="_blank"
        >
          {t('interstitials.modernBrowser.chrome', 'Get Chrome')}
        </ButtonLink>

        <ButtonLink
          href={firefoxLink}
          margin={2}
          marginBottom={0}
          target="_blank"
        >
          {t('interstitials.modernBrowser.firefox', 'Get Firefox')}
        </ButtonLink>

        <Button
          hierarchy="secondary"
          margin={2}
          marginBottom={0}
          onClick={props.onClickReject}
        >
          {t('common:noThanks', 'No thanks')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ModernBrowserPromptUI;
